/* src/app/ship/no-coverage-warning-dialog/no-coverage-warning-dialog.component.scss */
.dialog-header {
  position: relative;
}
.dialog-header .close-icon {
  position: absolute;
  top: 0.75em;
  right: 0.5em;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  row-gap: 1.5625rem;
  padding: 2.5rem;
  width: 100%;
  height: 100%;
  background-color: #FCEAE6;
  border: solid thin #d50000;
  border-radius: 0.25rem;
}
.dialog-content .title,
.dialog-content .subtitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.5rem;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}
.dialog-content .title {
  flex-direction: row-reverse;
}
@media screen and (min-width: 48rem) {
  .dialog-content .title {
    flex-direction: row;
  }
}
.dialog-content .title:first-of-type {
  margin-bottom: 0;
}
.dialog-content .title .mat-icon {
  font-size: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content .title .mat-icon {
    font-size: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
}
.dialog-content .title span {
  flex: 1;
}
.dialog-content p {
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  margin: 0;
}
.dialog-content .actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  row-gap: 1.5rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content .actions {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    column-gap: 1.5rem;
  }
}
.dialog-content .actions .action {
  padding: 0.62rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  height: 2.75rem;
}
.dialog-content .actions .action.mat-mdc-outlined-button:not([color]) {
  color: #0662BB;
  border: solid thin #0662BB;
  background-color: white;
}
:host(.no-coverage-warning-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=no-coverage-warning-dialog.component.css.map */
